module.exports = __webpack_public_path__ + "assets/just-eat-89636d.svg";